import URLConfig from '@Config/urls/url.config';
import { Route } from 'react-router-dom';
import * as BasicSettingsModule from '@Modules/admin/basicSettings/pages';
import React from 'react';

const basicSettingsRoutes = [
  // CENTER_MENU Routes
  <Route
    path={URLConfig.ADMIN.BASE_SETTINGS.CENTER_MENU.UPDATE}
    element={<BasicSettingsModule.BasicSettingsCenterUpdate />}
  />,
  <Route
    path={URLConfig.ADMIN.BASE_SETTINGS.CENTER_MENU.PAYMENT_SYSTEM}
    element={<BasicSettingsModule.BasicSettingsCenterPaymentSystem />}
  />,
  <Route
    path={URLConfig.ADMIN.BASE_SETTINGS.CENTER_MENU.DEVISE}
    element={<BasicSettingsModule.BasicSettingsCenterDevise />}
  />,
  <Route
    path={URLConfig.ADMIN.BASE_SETTINGS.CENTER_MENU.MERCHANT}
    element={<BasicSettingsModule.BasicSettingsCenterMerchant />}
  />,
  <Route
    path={URLConfig.ADMIN.BASE_SETTINGS.CENTER_MENU.BANK}
    element={<BasicSettingsModule.BasicSettingsCenterBank />}
  />,
  <Route
    path={URLConfig.ADMIN.BASE_SETTINGS.CENTER_MENU.CENTER_COMMISSION}
    element={<BasicSettingsModule.BasicSettingsCenterCenterCommission />}
  />,
  <Route
    path={URLConfig.ADMIN.BASE_SETTINGS.CENTER_MENU.TVA}
    element={<BasicSettingsModule.BasicSettingsCenterTVA />}
  />,
  <Route
    path={URLConfig.ADMIN.BASE_SETTINGS.CENTER_MENU.PARAMETERS.ROOT}
    element={<BasicSettingsModule.BasicSettingsCenterParameters />}
  >
    <Route
      path={
        URLConfig.ADMIN.BASE_SETTINGS.CENTER_MENU
        .PARAMETERS.COUNTRY
      }
      element={<BasicSettingsModule.CenterParametersCountry />}
    />
    <Route
      path={
        URLConfig.ADMIN.BASE_SETTINGS.CENTER_MENU
        .PARAMETERS.CITY
      }
      element={<BasicSettingsModule.CenterParametersCity />}
    />
    <Route
      path={
        URLConfig.ADMIN.BASE_SETTINGS.CENTER_MENU
        .PARAMETERS.COMPANY_TYPE
      }
      element={<BasicSettingsModule.CenterParametersCompanyType />}
    />
    <Route
      path={
        URLConfig.ADMIN.BASE_SETTINGS.CENTER_MENU
        .PARAMETERS.DOCUMENT_TYPE
      }
      element={<BasicSettingsModule.CenterParametersDocumentType />}
    />
    <Route
      path={
        URLConfig.ADMIN.BASE_SETTINGS.CENTER_MENU
        .PARAMETERS.CARD_OBJECTION_REASON
      }
      element={<BasicSettingsModule.CenterParametersCardObjectionReason />}
    />
    <Route
      path={
        URLConfig.ADMIN.BASE_SETTINGS.CENTER_MENU
        .PARAMETERS.BIN_OBJECTION_REASON
      }
      element={<BasicSettingsModule.CenterParametersBinObjectionReason />}
    />    
    <Route
      path={
        URLConfig.ADMIN.BASE_SETTINGS.CENTER_MENU
        .PARAMETERS.CORRESPONDANCE_TYPE
      }
      element={<BasicSettingsModule.CenterParametersCorrespondanceType />}
    />
    <Route
      path={
        URLConfig.ADMIN.BASE_SETTINGS.CENTER_MENU
        .PARAMETERS.ADDRESS_TYPE
      }
      element={<BasicSettingsModule.CenterParametersAddressType />}
    />
    <Route
      path={
        URLConfig.ADMIN.BASE_SETTINGS.CENTER_MENU
        .PARAMETERS.VACANCY_TYPE
      }
      element={<BasicSettingsModule.CenterParametersVacancyType />}
    />
    <Route
      path={
        URLConfig.ADMIN.BASE_SETTINGS.CENTER_MENU
        .PARAMETERS.TITLE
      }
      element={<BasicSettingsModule.CenterParametersTitle />}
    />
    <Route
      path={
        URLConfig.ADMIN.BASE_SETTINGS.CENTER_MENU
        .PARAMETERS.PROFESSIONAL_POSITION
      }
      element={<BasicSettingsModule.CenterParametersProfessionalPosition />}
    />
    <Route
      path={
        URLConfig.ADMIN.BASE_SETTINGS.CENTER_MENU
        .PARAMETERS.DELIVERY_OPERATOR
      }
      element={<BasicSettingsModule.CenterParametersDeliveryOperator />}
    />
    
  </Route>,

  // BANK MENU ROUTES
  <Route>
    {BankMenuRoutes().map((adminRoute, index) => (
      <React.Fragment key={index}>{adminRoute}</React.Fragment>
    ))}
  </Route>,
  //    x   BANK MENU ROUTES  x
  <Route>
    {AgenceMenuRoutes().map((adminRoute, index) => (
      <React.Fragment key={index}>{adminRoute}</React.Fragment>
    ))}
  </Route>,
];

function BankMenuRoutes() {
  return [
    <Route
      path={URLConfig.ADMIN.BASE_SETTINGS.BANK.UPDATE}
      element={<BasicSettingsModule.Update />}
    />,
    <Route
      path={URLConfig.ADMIN.BASE_SETTINGS.BANK.TRANSACTION_TYPE}
      element={<BasicSettingsModule.TransactionType />}
    />,
    <Route
      path={URLConfig.ADMIN.BASE_SETTINGS.BANK.PAYMENT_SYSTEM}
      element={<BasicSettingsModule.PaymentSystem />}
    />,
    <Route
      path={URLConfig.ADMIN.BASE_SETTINGS.BANK.CALENDAR}
      element={<BasicSettingsModule.Calendar />}
    />,
    <Route
      path={URLConfig.ADMIN.BASE_SETTINGS.BANK.DEVISE.ROOT}
      element={<BasicSettingsModule.Devise />}
    >
      <Route index element={<BasicSettingsModule.DeviseDefinition />} />,
      <Route
        path={URLConfig.ADMIN.BASE_SETTINGS.BANK.DEVISE.DIVISE_DEFINITION}
        element={<BasicSettingsModule.DeviseDefinition />}
      />
      ,
      <Route
        path={
          URLConfig.ADMIN.BASE_SETTINGS.BANK.DEVISE.CONVERSION_TAUX_CONSULTATION
        }
        element={<BasicSettingsModule.ConvertionTauxConsultation />}
      />
      <Route
        path={URLConfig.ADMIN.BASE_SETTINGS.BANK.DEVISE.UPDATE_CONVERSION_TAUX}
        element={<BasicSettingsModule.UpdateConvertionTaux />}
      />
    </Route>,
    <Route
      path={URLConfig.ADMIN.BASE_SETTINGS.BANK.MARCHANTS.ROOT}
      element={<BasicSettingsModule.Marchants />}
    >
      <Route index element={<BasicSettingsModule.MarchantsCategory />} />
      <Route
        path={URLConfig.ADMIN.BASE_SETTINGS.BANK.MARCHANTS.MARCHANT_CATEGORY}
        element={<BasicSettingsModule.MarchantsCategory />}
      />
      <Route
        path={URLConfig.ADMIN.BASE_SETTINGS.BANK.MARCHANTS.MARCHANT_GROUP}
        element={<BasicSettingsModule.MarchantsGroup />}
      />
      <Route
        path={
          URLConfig.ADMIN.BASE_SETTINGS.BANK.MARCHANTS.MARCHANT_CATEGORY_GROUP
        }
        element={<BasicSettingsModule.MarchantsCategoryGroup />}
      />
    </Route>,
    <Route
      path={URLConfig.ADMIN.BASE_SETTINGS.BANK.PROMOTOR}
      element={<BasicSettingsModule.Promotor />}
    />,
    <Route
      path={URLConfig.ADMIN.BASE_SETTINGS.BANK.BANK_COMMISSION.ROOT}
      element={<BasicSettingsModule.BankCommission />}
    >
      <Route index element={<BasicSettingsModule.BankCommissionPage />}></Route>
      <Route
        path={URLConfig.ADMIN.BASE_SETTINGS.BANK.BANK_COMMISSION.COMMISSION}
        element={<BasicSettingsModule.BankCommissionPage />}
      ></Route>

      <Route
        path={URLConfig.ADMIN.BASE_SETTINGS.BANK.BANK_COMMISSION.INTERCHANGE}
        element={<BasicSettingsModule.BankCommisionInterchange />}
      ></Route>
    </Route>,
    <Route
      path={URLConfig.ADMIN.BASE_SETTINGS.BANK.CONTRAT_TYPE}
      element={<BasicSettingsModule.ContratType />}
    />,
    <Route
      path={URLConfig.ADMIN.BASE_SETTINGS.BANK.SOLVIBILITY_LEVEL}
      element={<BasicSettingsModule.SovabilityLevel />}
    />,
    <Route
      path={URLConfig.ADMIN.BASE_SETTINGS.BANK.BIEN_DESC}
      element={<BasicSettingsModule.BienDescription />}
    />,
    <Route
      path={URLConfig.ADMIN.BASE_SETTINGS.BANK.INCOME_TYPE}
      element={<BasicSettingsModule.IncomeType />}
    />,
    <Route
      path={URLConfig.ADMIN.BASE_SETTINGS.BANK.CREANCIER_TYPE}
      element={<BasicSettingsModule.CreancierType />}
    />,
    <Route
      path={URLConfig.ADMIN.BASE_SETTINGS.BANK.ASSURANCE_TYPE}
      element={<BasicSettingsModule.AssuranceType />}
    />,
    <Route
      path={URLConfig.ADMIN.BASE_SETTINGS.BANK.IMPRESSION_SETTINGS}
      element={<BasicSettingsModule.ImpressionSettings />}
    />,
    <Route
      path={URLConfig.ADMIN.BASE_SETTINGS.BANK.IMPRESSION_SETTINGS_FIELDS}
      element={<BasicSettingsModule.ImpressionSettingsFields />}
    />,
    <Route
      path={URLConfig.ADMIN.BASE_SETTINGS.BANK.RISK_MANAGEMENT.ROOT}
      element={<BasicSettingsModule.RiskManagement />}
    >
      <Route index element={<BasicSettingsModule.RiskManagementAcquierer />} />

      <Route
        path={URLConfig.ADMIN.BASE_SETTINGS.BANK.RISK_MANAGEMENT.ACQUIERER}
        element={<BasicSettingsModule.RiskManagementAcquierer />}
      />

      <Route
        path={URLConfig.ADMIN.BASE_SETTINGS.BANK.RISK_MANAGEMENT.EMETTRICE}
        element={<BasicSettingsModule.RiskManagementEmettrice />}
      />
    </Route>,
  ];
}

function AgenceMenuRoutes() {
  return [
    <Route
      path={URLConfig.ADMIN.BASE_SETTINGS.AGENCE}
      element={<BasicSettingsModule.Agence />}
    />,
  ];
}

export default basicSettingsRoutes;
